import {useLocation, UseLocationReturn} from './useLocation';
import React from 'react';

export type WithLocationProps = UseLocationReturn;

export function withLocation<P extends object>(
  Wrapped: React.ComponentType<P & WithLocationProps>,
) {
  return function WithLocationProps(props: P) {
    const loc = useLocation();
    return <Wrapped {...props} {...loc} />;
  };
}
